export interface MrrByTypeRow {
  subscription_type: string;
  active_count: number;
  mrr: string;
}

export interface PipelineRow {
  project_type: string;
  rate_number: number;
  status: 'pending' | 'triggered' | 'invoice_created';
  rate_count: number;
  total_amount: string;
}

export interface MonthlySnapshot {
  snapshot_month: string;
  subscription_type: string;
  active_count: number;
  new_count: number;
  churned_count: number;
  mrr: string;
}

export interface PhaseSnapshot {
  snapshot_month: string;
  project_type: string;
  phase: string;
  count: number;
  total_value: string;
}

export interface RevenuePipelinePayload {
  generated_at: string;
  mrr_total: string;
  mrr_by_type: MrrByTypeRow[];
  pipeline: PipelineRow[];
  ad_hoc_pending_total: string;
  clients_new_this_month: number;
  clients_churned_this_month: number;
  mrr_trend: MonthlySnapshot[];
  phase_trend: PhaseSnapshot[];
}

export const SUBSCRIPTION_LABEL: Record<string, string> = {
  basic_hosting_support: 'Basic abo',
  seo_aeo: 'SEO/AEO',
  google_ads: 'Google Ads',
  meta_ads: 'Meta',
  linkedin_ads: 'LinkedIn Ads',
  linkedin_profilpleje: 'LinkedIn Profilpleje',
  maas: 'MaaS',
  other: 'Andet',
};

export const PROJECT_TYPE_LABEL: Record<string, string> = {
  website: 'Website',
  video: 'Video',
  pakkelosning: 'Pakkeløsning',
  klippekort: 'Klippekort',
};

export const PIPELINE_STATUS_LABEL: Record<PipelineRow['status'], string> = {
  pending: 'Afventer trigger',
  triggered: 'Udløst',
  invoice_created: 'Faktura oprettet',
};
